import React, { useState } from 'react';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    List
} from 'reactstrap';
import Layout from './Layout';

const Projects = props => {
    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <div>
            <Layout title='My Projects' className='container'>
                <p>Currently I am working on the following projects which are under development.</p>
                <Accordion open={open} toggle={toggle}>
                    <AccordionItem>
                        <AccordionHeader targetId="1">www.freelancebangla.com</AccordionHeader>
                        <AccordionBody accordionId="1">
                            <h3>This is my Entrepreneurship Project</h3>
                            <p><i>To view the source code:</i> <a href='https://github.com/19mddil/FREELANCEBANGLA-MERN-LOCAL'>https://github.com/19mddil/FREELANCEBANGLA-MERN-LOCAL</a> </p>
                            <p><i>To visit the webpage:</i> <a href='https://www.freelancebangla.com'>https://www.freelancebangla.com</a> </p>
                            <p>

                            </p>
                        </AccordionBody>
                    </AccordionItem>

                    <AccordionItem>
                        <AccordionHeader targetId="2">19mddil.github.io/ecommerce</AccordionHeader>
                        <AccordionBody accordionId="2">
                            <h3>This is a MERN project</h3>
                            <p><i>To view the source code:</i> <a href='https://github.com/19mddil/ECOMMERCE-MERN-LOCAL'>https://github.com/19mddil/ECOMMERCE-MERN-LOCAL</a> </p>
                            <p><i>To visit the webpage:</i> <a href='https://19mddil.github.io/ecommerce/'>https://19mddil.github.io/ecommerce/</a> </p>
                            <hr></hr>
                            <p>
                                This project is being developed for mini online businesses that help selling their products online via their domain websites. Its a Traditional Ecommerce webpage fully deployed where ,
                            </p>
                            <ul>
                                <li>user will see the products in the homepage but he/she has to signup should he/she choose to purchase them online.</li>
                                <li>Only admin can create product and categories.</li>
                                <li>After sign up user has access to webpage but he/she has to verify his email address.</li>
                                <li>If one forgets his password he can reset it.</li>
                                <li>And user can filter products, add them to cart, check them out and purchase them.</li>
                            </ul>
                            <p>
                                While this project was being developed deploying this project to free services like its database to MongoDB atlas and its react front-end app to GitHub pages took some technical skill test of mine which I successfully attributed. Also uploading its back-end API to cpanels node.js app was also very patientworthy work and pure technical. And all this full stack work I did it myself, alone.
                            </p>
                            <p>
                                Many technical, implementational and logical problem occurred during the development of its backend, frontend and database design which required a lot of documentation reading, testing and debugging. This took time to develop the website but I successfully overcame them.
                            </p>
                            <p>
                                This project is still under some development (as new thoughts of it features come into my mind) and currently I am working on its notification system sending to user, for example: notifications on offers, new product add etc.
                            </p>
                            <p>
                                This project has benefited me by following:
                            </p>
                            <ul>
                                <li>I read a lot of documentations and books on nodejs, reactjs, mongodb, payment API docs, SMTP docs and MongoDB atlas, javascript(es6).</li>
                                <li>By doing this project I learned the working flow of node.js & express.js and became familiar with MongoDB database management system which was very fun to work with and a new view of queries for the database rather than SQL. The project has strong relational database concept between users, products and orders all done using mongoDB.</li>
                                <li>In this project I connected commercial demo payment api to its backend which was very technical. As a developer I feel wholesome to connect the payment API to my eCommerce Webpage.</li>
                                <li>I also deployed its backend API to a cpanel node.js app and frontend to github pages and its database to mongodb atlas website. Deploying is always really technical and I made it. This makes me feel like a more wholesome developer.</li>
                                <li>In this projects I used SMTP mail services of cpanel to send email to users for verifying email and forgetting password features.</li>
                                <li>Also I used React.js for its frontend and React was really exciting to know about reacts pros and cons like components(class or functional), states, hooks, passing props and applying these to my project thus knowing more better about them.</li>
                                <li>I faced many logical and implementational problem while I was developing the project but I solved them and had a great technical experience.</li>
                            </ul>
                            <p>
                                So, the best outcome of the project I think is that now I feel I can work professionally under proper guidance.
                            </p>
                            <button type="button" class="btn btn-outline-success">JavaScript</button> <button type="button" class="btn btn-outline-success">Node.js</button> <button type="button" class="btn btn-outline-success">MongoDB</button> <button type="button" class="btn btn-outline-success">React</button> <button type="button" class="btn btn-outline-success">Express.js</button> <button type="button" class="btn btn-outline-success">E-Commerce</button> <button type="button" class="btn btn-outline-success">SMTP</button>
                        </AccordionBody>
                    </AccordionItem>

                    <AccordionItem>
                        <AccordionHeader targetId="3">19mddil.github.io/19mddil</AccordionHeader>
                        <AccordionBody accordionId="3">
                            <h3>This is a portfolio project</h3>
                            <p><i>To view the source code:</i> <a href='https://github.com/19mddil/19mddil'>https://github.com/19mddil/19mddil</a> </p>
                            <p><i>To visit the webpage:</i> <a href='https://19mddil.github.io/19mddil/'>https://19mddil.github.io/19mddil/</a> </p>
                            <hr></hr>
                            The following features are under development
                            <List>
                                <li>
                                    My many certificats are to be added.
                                </li>
                            </List>
                        </AccordionBody>
                    </AccordionItem>

                </Accordion>
            </Layout>
        </div>
    );
}

export default Projects;